module.exports = __webpack_public_path__ + "static/overtime.dfbaf98a.svg";